export class RedirectToDestinationController {
    /* @ngInject */
    constructor(destinationRedirectData, flowStateService) {
        this.redirectUrl = destinationRedirectData.redirectUrl;
        this.flowStateService = flowStateService;
    }

    $onInit() {
        this.redirectPayload = {
            'X-EGTO-SESSION': this.flowStateService.getInstallationSessionId(),
        };
    }
}
